export default "__VITE_ASSET__DV64hvDY__"